import styled from 'styled-components'

import ToggleButton from '../../../ToggleButton'

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.textMedium}
  color: ${({ theme }) => theme.colors.pureWhite};
  background-color: rgba(51, 51, 51, 0.85);
  padding: 0.8rem 1.6rem;
  border-radius: 1rem;
  position: absolute;
  top: 90%;
  right: 20%;
  visibility: hidden;
  z-index: 10;
`

export const Container = styled.div`
  position: relative;

  &:hover > ${Help} {
    visibility: visible;
  }
`

export const Button = styled(ToggleButton)``

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.text}
  color: ${({ theme }) => theme.colors.red};
  margin-top: 0.5rem;
`
